<template>
  <a-config-provider :locale="locale">
    <div id="app" class="overflow-hidden">
      <home-page-header :showMenu="!this.$route.path.includes('apply')" />

      <div class="flex flex-col">
        <router-view />
        
        <home-page-footer />
      </div>
    </div>
  </a-config-provider>
</template>

<script>
import '@/styles/tailwind.css';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import HomePageHeader from '@/views/home-page/components/header';
import HomePageFooter from '@/views/home-page/components/footer';

export default {
  name: 'App',
  components: {
    HomePageHeader,
    HomePageFooter
  },
  data() {
    return {
      locale: zhCN
    }
  }
}
</script>
